module.exports = __webpack_public_path__ + "img/my-type-4.fa37543e.png";